import { APP_NAME } from '../constants';

export const CGV_LAST_UPDATED = '21/08/2026';

export const CGV_CANCELLATION_FEES = [
  { delay: '72 h ou plus', fee: '0 €' },
  { delay: 'Entre 48 h et moins de 72 h', fee: '30 €' },
  { delay: 'Entre 24 h et moins de 48 h', fee: '40 €' },
  { delay: 'Moins de 24 h', fee: '50 €' },
  { delay: 'Absence du client au rendez-vous', fee: '50 €' },
];

export const getCgvDocument = (brandName = APP_NAME) => ({
  title: 'Conditions Générales de Vente (CGV)',
  lastUpdatedLabel: `Dernière mise à jour : le ${CGV_LAST_UPDATED}`,
  intro: `Les présentes Conditions Générales de Vente (CGV) s'appliquent à l'ensemble des prestations proposées par ${brandName} auprès de ses clients particuliers et professionnels.`,
  sections: [
    {
      id: 'objet',
      number: '1',
      title: 'Objet',
      paragraphs: [
        `${brandName} réalise des prestations de plomberie, dépannage, installation, entretien, réparation et rénovation, selon les services présentés sur son site internet.`,
        'Toute commande implique l\'acceptation pleine et entière des présentes CGV.',
      ],
    },
    {
      id: 'prix-devis-commande',
      number: '2',
      title: 'Prix, devis et commande',
      paragraphs: [
        'Le prix de la prestation est communiqué au client avant le début de l’intervention. Pour les prestations dont la nature et les caractéristiques permettent de déterminer le prix à l’avance, le montant de la prestation est indiqué au client lors de la prise de rendez-vous ou avant toute intervention.',
        'Certaines prestations, notamment lorsque leur nature, leur durée ou l’étendue des travaux ne peuvent pas être déterminées avec précision avant intervention, peuvent nécessiter l’établissement d’un devis préalable.',
        'Lorsque l’établissement d’un devis est nécessaire, celui-ci précise notamment la nature des travaux envisagés, leur prix et, le cas échéant, les éventuelles conditions particulières. La commande est réputée acceptée dès la signature du devis ou toute autre acceptation écrite du client.',
        'Pour les interventions urgentes ou les prestations dont le prix est communiqué avant le début des travaux, l’accord exprès du client sur le prix communiqué vaut acceptation de la prestation. Cet accord peut être recueilli par tout moyen permettant d’en conserver la preuve.',
        'Aucune prestation donnant lieu à une facturation ne débute sans que le client ait été informé au préalable de son prix ou, lorsque celui-ci ne peut être déterminé à l’avance, des modalités de détermination de son prix.',
      ],
    },
    {
      id: 'prix',
      number: '3',
      title: 'Prix',
      paragraphs: [
        'Les prix sont exprimés en euros.',
        'Le prix applicable est communiqué au client avant la validation de la commande. Le montant facturé peut varier selon le statut du client et le régime de TVA applicable à la prestation, notamment selon qu’il s’agit d’un client particulier ou d’un client professionnel.',
        'Pour les prestations dont le prix peut être déterminé à l’avance, le montant applicable au client est affiché ou communiqué avant la commande.',
        'Lorsque le prix d’une prestation ne peut pas être déterminé avec précision à l’avance, notamment en raison de la nature ou de l’étendue des travaux à réaliser, un devis précisant le montant de la prestation et, le cas échéant, les conditions applicables, est soumis à l’acceptation du client avant le début des travaux.',
        'Toute prestation complémentaire non comprise dans la commande initiale fait l’objet d’une information préalable du client et de son accord avant sa réalisation.',
      ],
    },
    {
      id: 'paiement',
      number: '4',
      title: 'Paiement',
      paragraphs: [
        'Le paiement de la prestation est effectué en ligne au moment de la commande, avant le début de l’intervention.',
        'La commande est considérée comme définitive après confirmation du paiement.',
        'Les moyens de paiement disponibles sont ceux proposés sur la plateforme de commande au moment du paiement.',
        'Aucun paiement sur place ni paiement différé n’est prévu, sauf accord exprès et préalable du professionnel.',
        'En cas d’échec ou de refus du paiement, la commande ne pourra pas être confirmée et l’intervention ne pourra pas être planifiée.',
      ],
    },
    {
      id: 'execution',
      number: '5',
      title: 'Exécution des prestations',
      paragraphs: [
        `${brandName} s'engage à réaliser les prestations dans les règles de l'art.`,
        'Les délais d\'intervention sont donnés à titre indicatif et peuvent varier en fonction des contraintes techniques, des conditions d\'accès ou de cas de force majeure.',
      ],
    },
    {
      id: 'garanties',
      number: '6',
      title: 'Garanties',
      paragraphs: [
        'Les prestations bénéficient des garanties légales applicables.',
        'Lorsque la nature des travaux l\'impose, les garanties légales et les assurances professionnelles obligatoires s\'appliquent conformément à la réglementation.',
      ],
    },
    {
      id: 'retractation-annulation',
      number: '7',
      title: 'Droit de rétractation et annulation',
      paragraphs: [
        'Pour les contrats conclus à distance ou hors établissement, le client consommateur bénéficie, lorsqu’il y est éligible, du droit de rétractation prévu par les articles L.221-18 et suivants du Code de la consommation.',
        'Lorsque le client demande expressément que la prestation débute avant l’expiration du délai légal de rétractation, il reconnaît que cette demande est soumise aux conditions et limites prévues par la réglementation applicable. En particulier, lorsque la prestation est pleinement exécutée avant la fin du délai de rétractation, après accord exprès du client et renoncement exprès à son droit de rétractation, ce droit ne peut plus être exercé.',
        'En dehors des cas dans lesquels le droit légal de rétractation s’applique, toute annulation d’une prestation préalablement planifiée peut entraîner des frais d’annulation, selon le délai entre l’annulation et l’heure prévue de l’intervention :',
      ],
      table: {
        caption: 'Frais d’annulation selon le délai avant l’intervention',
        headers: ['Délai avant l’intervention', 'Frais d’annulation'],
        rows: CGV_CANCELLATION_FEES.map((row) => [row.delay, row.fee]),
      },
    },
    {
      id: 'responsabilite',
      number: '8',
      title: 'Responsabilité',
      paragraphs: [
        `${brandName} ne pourra être tenue responsable des dommages résultant d'une installation préexistante défectueuse, vétuste, non conforme ou d'une utilisation anormale des équipements.`,
      ],
    },
    {
      id: 'reclamations-litiges',
      number: '9',
      title: 'Réclamations et litiges',
      paragraphs: [
        'Toute réclamation devra être adressée dans les meilleurs délais afin de rechercher une solution amiable.',
        'À défaut d\'accord amiable, les litiges relèveront des juridictions compétentes conformément au droit français.',
      ],
    },
    {
      id: 'droit-applicable',
      number: '10',
      title: 'Droit applicable',
      paragraphs: [
        'Les présentes CGV sont régies par le droit français.',
      ],
    },
  ],
});
